export const getOrganeTypeName = (organe) => {
  if (!organe) return ''
  let typeName = ''
  if (organe.type.id === 1) typeName = 'Fédération'
  else if (organe.type.id === 4) typeName = 'Coordination'
  else if (organe.type.id === 2) typeName = 'Section'
  else if (organe.type.id === 3) typeName = 'Cellule'
  else if (organe.type.id === 7) typeName = 'Interfédération'

  return typeName
}

export const organeIsChildOf = (organe, parent) => {
  let _organe = organe
  while (_organe) {
    if (_organe.id == parent.id) return true
    _organe = _organe.parent
  }

  return false
}

export const organeGetParentOfType = (organe, typeId) => {
  if (!organe) return null
  let _organe = organe
  while (_organe) {
    if (_organe.type.id == typeId) return _organe
    _organe = _organe.parent
  }

  return null
}

export const getMemberFullName = (member) => {
  return !member
    ? ''
    : `${member.lastName ?? ''} ${member.middleName ?? ''} ${member.firstName ?? ''}`
}

export const isStrongPassword = (password) => {
  const strongPassword = new RegExp('(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[^A-Za-z0-9])(?=.{8,})')
  return strongPassword.test(password)
}
